import * as THREE from 'three';
import type { GlanceDir } from '../sim/types';

/** Cámara de persecución suavizada (3ª persona). */
export class ChaseCamera {
  readonly camera = new THREE.PerspectiveCamera(60, 16 / 9, 0.1, 600);
  private current = new THREE.Vector3(0, 3, -8);
  private initialized = false;
  private tmpFwd = new THREE.Vector3();
  private tmpTarget = new THREE.Vector3();
  private tmpDesired = new THREE.Vector3();

  update(pos: THREE.Vector3, quat: THREE.Quaternion, dt: number): void {
    this.tmpFwd.set(0, 0, 1).applyQuaternion(quat);
    this.tmpFwd.y = 0;
    if (this.tmpFwd.lengthSq() < 1e-6) this.tmpFwd.set(0, 0, 1);
    this.tmpFwd.normalize();
    this.tmpDesired
      .copy(pos)
      .addScaledVector(this.tmpFwd, -7.2)
      .add(new THREE.Vector3(0, 2.7, 0));
    if (!this.initialized) {
      this.current.copy(this.tmpDesired);
      this.initialized = true;
    } else {
      const k = 1 - Math.exp(-6 * dt);
      this.current.lerp(this.tmpDesired, k);
    }
    this.camera.position.copy(this.current);
    this.tmpTarget.copy(pos).addScaledVector(this.tmpFwd, 4).add(new THREE.Vector3(0, 1.1, 0));
    this.camera.lookAt(this.tmpTarget);
  }
}

/** Cámara de cabina con giro de cabeza al mirar espejos. */
export class CockpitCamera {
  readonly camera = new THREE.PerspectiveCamera(68, 16 / 9, 0.05, 600);
  private glanceYaw = 0;
  private seat = new THREE.Vector3(-0.37, 1.14, 0.18); // conducción por la izquierda del habitáculo
  private tmpPos = new THREE.Vector3();
  private baseQuat = new THREE.Quaternion();
  private glanceQuat = new THREE.Quaternion();
  private flip = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI);

  update(pos: THREE.Vector3, quat: THREE.Quaternion, glance: GlanceDir, dt: number): void {
    this.tmpPos.copy(this.seat).applyQuaternion(quat).add(pos);
    this.camera.position.copy(this.tmpPos);
    // La cámara mira hacia -Z; el coche avanza por +Z → girar 180°
    this.baseQuat.copy(quat).multiply(this.flip);
    const targetYaw = glance === 'left' ? 0.85 : glance === 'right' ? -0.85 : 0;
    this.glanceYaw += (targetYaw - this.glanceYaw) * (1 - Math.exp(-10 * dt));
    this.glanceQuat.setFromAxisAngle(new THREE.Vector3(0, 1, 0), this.glanceYaw);
    this.camera.quaternion.copy(this.baseQuat).multiply(this.glanceQuat);
  }
}
